/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultNiveau } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_gov_013: Question = {
  id: 'gov-013-programmes-conservation',
  oldId: '13',
  title: 'Participation à un ou plusieurs programmes de conservation',
  number: '1.13',
  idEM: 14,
  frequency: 1,
  type: QuestionType.ACTIVITY,
  description: [''],
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      score: '0',
      scoringFct: (data: string[]) => parseFloat(data[0]),
      maxScore: 1,
      help: defaultNiveau,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_gov_013__v3: Question = {
  ...question_gov_013,
  title: 'Participation financière à un ou plusieurs programmes de conservation',
  number: '1.10',
};

export const question_gov_013_v2: Question = question_gov_013;
export const question_gov_013_v3: Question = question_gov_013__v3;
